import { useContext } from 'react';
import { ISPContext, ISPMutatorContext } from './ispContexts';

export const useIspSelector = () => useContext(ISPContext);
export const useIspMutator = () => useContext(ISPMutatorContext);
